/*
  <fd-recommendations data-url="…"> – loads product recommendations lazily.

  The section renders an empty, hidden element. When it is about to scroll into
  view we request the same section through the Section Rendering API
  (/recommendations/products?section_id=…&product_id=…), which returns the
  section with `recommendations` populated. The returned [data-fd-reco-content]
  (a heading + <fd-carousel> of product cards) is moved into the element.
  No results or a failed request keep the whole section hidden.
*/
(function () {
  'use strict';

  if (!window.customElements || window.customElements.get('fd-recommendations')) return;

  class FDRecommendations extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.url = this.dataset.url;
      if (!this.url || this.querySelector('[data-fd-reco-content]')) return;

      var self = this;
      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver(function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) {
            self._observer.disconnect();
            self.load();
          }
        }, { rootMargin: '300px 0px' });
        // A hidden element has no box and would never intersect, so watch its parent.
        this._observer.observe(this.parentElement || this);
      } else {
        this.load();
      }
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
      this._ready = false;
    }

    load() {
      var self = this;
      fetch(this.url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('[data-fd-reco-content]');
          if (!content || !content.querySelector('.fd-carousel__slide')) return self.fail();
          self.textContent = '';
          self.appendChild(document.importNode(content, true));
          self.hidden = false;
          var wrapper = self.closest('.shopify-section');
          if (wrapper) wrapper.hidden = false;
          document.dispatchEvent(new CustomEvent('fd:recommendations:loaded', { detail: { element: self } }));
        })
        .catch(function () { self.fail(); });
    }

    fail() {
      this.hidden = true;
      var wrapper = this.closest('.shopify-section');
      if (wrapper && !(window.Shopify && window.Shopify.designMode)) wrapper.hidden = true;
    }
  }

  window.customElements.define('fd-recommendations', FDRecommendations);
})();
